import React from "react";
import { Box, Grid, Paper, Stack, Typography } from "convertupleads-theme";
import TextButtonMedium from "./TextBtnComponents/TextButtonMedium";
import TextButtonSmall from "./TextBtnComponents/TextButtonSmall";
import TextButtonDisabled from "./TextBtnComponents/TextButtonDisabled";
import TextButtonWithStartIcon from "./TextBtnComponents/TextButtonWithStartIcon";
import TextButtonWithEndIcon from "./TextBtnComponents/TextButtonWithEndIcon";
import TextBtnWithIcons from "./TextBtnComponents/TextBtnWithIcons";
import TextLoadingButton from "./TextBtnComponents/TextLoadingButton";
import TextButtonLarge from "./TextBtnComponents/TextButtonLarge";

const TextButtons = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Text Button
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          this is the button only contains text without any background color or
          outlined style.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={6}>
            <TextButtonLarge />
          </Grid>
          <Grid item xs={6}>
            <TextButtonMedium />
          </Grid>
          <Grid item xs={6}>
            <TextButtonSmall />
          </Grid>
          <Grid item xs={6}>
            <TextButtonDisabled />
          </Grid>
          <Grid item xs={6}>
            <TextButtonWithStartIcon />
          </Grid>
          <Grid item xs={6}>
            <TextButtonWithEndIcon />
          </Grid>
          <Grid item xs={6}>
            <TextBtnWithIcons />
          </Grid>
          <Grid item xs={6}>
            <TextLoadingButton />
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default TextButtons;
